import { render, staticRenderFns } from "./import-reserved-stock.vue?vue&type=template&id=b053525c&scoped=true&"
import script from "./import-reserved-stock.vue?vue&type=script&lang=js&"
export * from "./import-reserved-stock.vue?vue&type=script&lang=js&"
import style0 from "./import-reserved-stock.vue?vue&type=style&index=0&id=b053525c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b053525c",
  null
  
)

export default component.exports